import { useCallback } from 'react';
import { useRouter } from 'next/router';

import { logger } from '@zep/core-logger';

import type { QuizSetDetailsRes } from '@/api/gen/_model/quizSetDetailsRes';

import { hasFlashcardCards } from '../../../flashcard/utils';

interface UseFlashcardHandlerParams {
  quizId: string;
  quizData: QuizSetDetailsRes;
}

/**
 * useFlashcardHandler - 플래시카드 학습 페이지 진입 핸들러
 *
 * @description
 * 퀴즈 상세에서 "플래시카드" 버튼을 눌렀을 때 `/quiz/[id]/flashcard`로 이동합니다.
 */
export const useFlashcardHandler = ({
  quizId,
  quizData,
}: UseFlashcardHandlerParams) => {
  const router = useRouter();

  return useCallback(() => {
    if (!hasFlashcardCards(quizData.quizList)) return;

    logger.track('flashcard_button_click', {
      quizSetId: quizData.id,
      title: quizData.title,
    });
    void router.push(`/quiz/${quizId}/flashcard`);
  }, [router, quizId, quizData]);
};
